import type { ReactNode } from 'react';

export const symbol_cyclone: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M480-330q-62 0-106-44t-44-106q0-63 44-106.5T480-630q63 0 106.5 43.5T630-480q0 62-43.5 106T480-330Zm0-60q38 0 64-26.5t26-63.5q0-38-26-64t-64-26q-37 0-63.5 26T390-480q0 37 26.5 63.5T480-390Zm0 232q-119 0-211.5-15T114-205q-14-4-24-15t-10-26q0-12 10.5-19t23.5-3q48 14 91.5 22.5T271-233q-55-45-84-113.5T158-480q0-119 15-211.5T205-846q4-14 15-24t26-10q12 0 19 10.5t3 23.5q-14 48-22 90.5T235-691q48-55 114-83t131-28q119 0 211.5 15T846-755q14 4 24 15t10 26q0 12-10.5 19t-23.5 3q-48-14-90.5-22.5T691-726q57 49 84 115t27 131q0 119-15 211.5T755-114q-4 14-15 24t-26 10q-12 0-19.5-10.5T691-114q14-48 22.5-90.5T726-269q-51 58-116 84.5T480-158Zm185.5-136.5Q742-371 742-480t-76.5-185.5Q589-742 480-742t-185.5 76.5Q218-589 218-480t76.5 185.5Q371-218 480-218t185.5-76.5Z"
		/>
	</svg>
);
